module.exports = __webpack_public_path__ + "img/20200117155940954.40c2434e.jpg";